import axios, { AxiosInstance } from 'axios';
import {
  authRequestInterceptor,
  authRequestErrorInterceptor,
  authResponseInterceptor,
  authResponseErrorInterceptor,
} from '../interceptors';
import { defaultHeaders } from '../headers';
import { API_TIMEOUT } from '@/config/env';

/**
 * Base API client factory
 * Creates an axios instance with authentication and error handling
 * All responses are transformed to StandardApiResponse format
 */
export const createBaseClient = (
  baseURL: string,
  clientName: string
): AxiosInstance => {
  const client = axios.create({
    baseURL,
    timeout: API_TIMEOUT,
    headers: defaultHeaders,
  });

  // Add request interceptors
  client.interceptors.request.use(
    authRequestInterceptor(clientName),
    authRequestErrorInterceptor
  );

  // Add response interceptors
  // Note: Using type assertion because axios interceptors expect AxiosResponse,
  // but we're transforming to StandardApiResponse
  client.interceptors.response.use(
    authResponseInterceptor as any,
    authResponseErrorInterceptor(clientName) as any
  );

  return client;
};
